import React, { useEffect } from 'react';
import { useStopwatch } from 'react-timer-hook';
import classNames from 'classnames';

const MyStopwatch = ({stopClock, startClock}) => {
  const {
          seconds,
          minutes,
          pause,
          start
        } = useStopwatch({autoStart: false, format: '12-hour'});

  useEffect(() => {
    if (stopClock == true) {
      pause();
    }
    return () => {};
  }, [stopClock]);

  useEffect(() => {
    if (startClock == true) {
      start();
    }
    return () => {};
  }, [startClock]);

  const addZeroLeft = (number) => {
    if (number > 9) {
      return <span>{number}</span>;
    } else {
      return <span>0{number}</span>;
    }
  };

  return (
    <span className={classNames('badge', {
      'bg-success text-white animate__animated animate__heartBeat animate__infinite': (stopClock == true),
      'bg-light text-muted':                                                          (stopClock == false)
    })}>
      <i className='fas fa-stopwatch' />
      <span> - </span>
      <span>{addZeroLeft(minutes)}:{addZeroLeft(seconds)}</span>
    </span>
  );
};

const CardBase = ({numeroProcesso, children, started, finished}) => (
  <>
    <div className='d-flex justify-content-center pt-5 animate__animated animate__zoomIn'>
      <div className='col-12 mt-2'>
        <div className='card mt-2'>
          <div className='card-header text-center bg-primary text-white py-1'>
            <small className='my-0'>PROCESSO Nº:</small>
            <h3 className='my-0'>{numeroProcesso}</h3>
            <div>
              <span className='badge bg-warning text-white small'>COM SUB-PROCESSOS</span>
              <> | <MyStopwatch stopClock={finished} startClock={started} /></>
            </div>
          </div>

          <div className='card-body'>
            <div className='row'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default React.memo(CardBase);
